import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpHeaders as Headers } from '@angular/common/http';
// import { StateService } from '@uirouter/angular';
import { Router, ActivatedRoute } from '@angular/router';

import { SocketService } from './socket.service';
import { UserService } from './user.service';
import { CommonRequestService } from './common-request.service';
import { AppSettings } from './../app.settings';
import { AuthTokenService } from './auth-token.service';
import { ClearService } from './clear.service';

@Injectable()
export class AuthService {

	private tokenUpdateInterval;

	constructor(
		// private stateService: StateService,
		private jwtHelper: JwtHelperService,
		private clearService: ClearService,
		private socketService: SocketService,
		private tokenService: AuthTokenService,
		private userService: UserService,
		private requestService: CommonRequestService
	) { }

	login(email, password?, successCallback?, errorCallback?) {
		const body: any = {
			email: email,
			// password: password
			// application: AppSettings.appName
		};
		// TODO. curretly authentication check will pass even without a password
		if (password) {
			body.password = password;
		}
		// prevState will be set in login.component
		// const prevStateInfo = sessionStorage.getItem('prevState');
		return this.requestService.requestPost(AppSettings.serviceRootUrl + 'admin/login', body, successCallback, errorCallback, true);
	}

	// Register a new agency
	// This function should not be called alone. Call together with sendVerifyEmail
	registerAgency(agencyNameShort, adminEmail, password, agencyNameLong?, parentId?: number) {
		return new Promise<any>((resolve, reject) => {
			const body: any = {
				customerShortName: agencyNameShort,
				email: adminEmail,
				password: password
			};
			if (agencyNameLong) {
				body.customerLongName = agencyNameLong;
			}
			if (parentId) {
				body.parentId = parentId;
			}
			this.requestService.requestPost(AppSettings.serviceRootUrl + 'admin/customer', body, rsp => resolve(rsp), err => reject(err), true);	
		});
	}
	// Send an link to the email regesitered as admin for verification
	// User will use a link in that email to activate their newly-created account
	sendVerifyEmail(email, agencyName) {
		return new Promise((resolve, reject) => {
			const body = {
				email: email,
				agency: agencyName, // Agency name to display in the email
				emailLinkRoot: AppSettings.rootLink + 'auth/verify',
				// NOTE: approveEmailLinkRoot is NOT used in AZGIV!!!!!!!
				approveEmailLinkRoot: AppSettings.portalRootLink + 'auth/register-approve'
			};
			this.requestService.requestPost(AppSettings.serviceRootUrl + 'admin/register', body, rsp => resolve(rsp), err => reject(err), true);	
		});
	}
	// Activate user after they verify email
	activateUser(token: string) {
		return new Promise((resolve, reject) => {
			const info = this.jwtHelper.decodeToken(token);
			// Update user status (activate user)
			const urlUpdate = AppSettings.serviceRootUrl + 'admin/user';
			const bodyUpdate = {
				email: info.email,
				state: 'ACTIVE'
			};
			this.requestService.requestPut(urlUpdate, bodyUpdate, rsp => resolve(rsp), err => reject(err), true);
		});
	}

	// Send an link to the email regesitered as admin for verification
	registerAgencyConfirm(email, successCallback?, errorCallback?) {
		const body = {
			email: email,
			emailLinkRoot: AppSettings.rootLink + 'auth/register/verify'
		};
		this.requestService.requestPost(AppSettings.serviceRootUrl + 'admin/register', body, successCallback, errorCallback, true);
	}
	// Veriry Link and the newly registered admin set the password
	registerVerify(password, token, successCallback?, errorCallback?) {
		const info = this.jwtHelper.decodeToken(token);
		const body = {
			email: info.usr_email,
			password: password,
			// application: AppSettings.appName,
			state: 'ACTIVE' // 1025 // TODO
		};
		const headers = new Headers({
			Authorization: 'Bearer ' + token
		});
		this.requestService.requestPut(AppSettings.serviceRootUrl + 'admin/user', body, successCallback, errorCallback, true, headers);
	}
	// Update password
	updatePw(password: string, token: string, isUpdateUserState?: boolean) {
		return new Promise((resolve, reject) => {
			let info;
			try {
				info = this.jwtHelper.decodeToken(token);
			} catch (err) {
				console.log('Invalid Token.');
				reject(err);
				return;
			}
			const body: any = {
				email: info.email,
				password: password
			};
			if (isUpdateUserState) {
				body.state = 'ACTIVE';
			}
			const headers = new Headers({
				Authorization: 'Bearer ' + token
			});
			this.requestService.requestPut(AppSettings.serviceRootUrl + 'admin/user', body, rsp => resolve(rsp), err => reject(err), true, headers);	
		});
	}


	// Invite user: send an email to the invited user
	inviteUser(email: string) {
		return new Promise((resolve, reject) => {
			const body = {
				email: email,
				emailLinkRoot: AppSettings.portalRootLink + 'auth/set-pw'
			};
			this.requestService.requestPost(AppSettings.serviceRootUrl + 'admin/invite', body, rsp => resolve(rsp), err => reject(err));
		});
	}

	// Sent an email to account to reset password
	retrievePw(email: string, successCallback?, errorCallback?) {
		const body = {
			email: email,
			emailLinkRoot: AppSettings.rootLink + 'auth/resetpw'
		};
		return this.requestService.requestPost(AppSettings.serviceRootUrl + 'admin/reset', body, successCallback, errorCallback, true);
	}

	// Set App to update koken automatically every XX second
	setTokenUpdateInterval() {
		console.log('set token update interval');
		if (this.tokenUpdateInterval) {
			clearInterval(this.tokenUpdateInterval);
		}
		this.tokenUpdateInterval = setInterval(() => {
			this.updateToken();
		}, 560000);
	}
	clearTokenUpdateInterval() {
		console.log('clear token update interval. Warning: Token Stop Updating!!!');
		if (this.tokenUpdateInterval) {
			clearInterval(this.tokenUpdateInterval);
			this.tokenUpdateInterval = null;
		}
	}
	updateToken() {
		return new Promise<void>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/login';
			this.requestService.requestGet(url, null, async (rsp) => {
				const token = rsp.data.content;
				await this.userService.setUpdatedToken(token);
				// this.token = token;
				// localStorage.setItem(this.tokenService.authTokenName, token);
				// this.userService.setUserInfoFromToken();
				// // Update customerInfo
				// await this.userService.getCustomerInfo(this.userService.getUserInfo().customerId, true, true);
				resolve();
			}, err => {
				if (err.error.error.errorDetail === 'jtw expired') {
					this.clearService.logout();
				}
				// console.log(this.token, this.jwtHelper.isTokenExpired(this.token));
				// console.log('isTokenExpired: ', this.isTokenExpired());
				reject(err);
			});
		});
	}

	// TO Delete
	test() {
			// const headers: any = {
			// 	// 'content-length': 114,
			// 	// 'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
			// 	// "enctype": "multipart/form-data",
			// 	'Accept': 'application/json;odata=verbose'
			// 	// 'content-type': 'application/Json',
			// 	// 'host': '192.168.0.129:8080'
			// };
			const headers = new Headers();
			headers.append('Accept', 'application/json');
			// headers.delete('Content-Type');
			// headers.delete('Accept');
			// headers.set('Accept', 'text/html, application/xhtml+xml, application/xml;q=0.9, */*;q=0.8');
			headers.set('Content-Type', 'application/x-www-form-urlencoded');
			headers.set('Cache-Control', 'no-cache');
			const dataRequestObj = {
				service: 'WFS',
				version: '1.0.0',
				request: 'GetFeature',
				typeName: 'emap:ADDRESSES',
				CQL_FILTER: 'ESN=\'001\'',
				outputFormat: 'CSV'
			};
			const formData = new FormData();
			formData.append('service', 'WFS');
			formData.append('version', '1.0.0');
			formData.append('request', 'GetFeature');
			formData.append('typeName', 'emap:ADDRESSES');
			formData.append('CQL_FILTER', 'ESN=\'001\'');
			formData.append('outputFormat', 'CSV');

			const bodyParams = new URLSearchParams();
			bodyParams.set('service', 'WFS');
			bodyParams.set('version', '1.0.0');
			bodyParams.set('request', 'GetFeature');
			bodyParams.set('typeName', 'emap:ADDRESSES');
			bodyParams.set('CQL_FILTER', 'ESN=\'001\'');
			bodyParams.set('outputFormat', 'CSV');
			this.requestService.requestPost('http://192.168.88.129:8081/geoserver/emap/ows', formData, (rsp) => {
				debugger
			}, (err) => {
				debugger
			}, true, {
				headers: headers
			});
			// request.post({ url: "http://192.168.0.129:8080/geoserver/emap/ows", form: dataRequestObj}, (err, rsp, body) => {
			// 	debugger
			// });
		}

}
